import { Injectable } from '@angular/core'
import { PreloadingStrategy, Route } from '@angular/router'
import { Observable, switchMap, timer } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class IdlePreload implements PreloadingStrategy {
  preload(_: Route, load: () => Observable<unknown>): Observable<unknown> {
    let timeoutOrIdle: Observable<unknown>
    // Use requestIdleCallback if available, otherwise fallback to a timer
    if ('requestIdleCallback' in window) {
      timeoutOrIdle = new Observable<void>((subscriber) => {
        window.requestIdleCallback(() => {
          subscriber.next()
          subscriber.complete()
        })
      })
    } else {
      timeoutOrIdle = timer(10000)
    }
    return timeoutOrIdle.pipe(switchMap(() => load()))
  }
}
